import React from 'react';
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import RadioButton from "./RadioBig";
import {trackConversion} from "../utils/analytics";
import { Trans } from '../utils/i18n';

export const ProductCategoryProductSelect = React.memo(function ({ values, mode, form, productValues, amountOptions, }) {
        const orderEntryDispatch = useFormStateDispatch();
        const { selectedCategory, selectedCategoryProduct } = useFormState();

        if (!selectedCategory) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        return (
            <div>
                <div className={'grid grid-cols-10 gap-6'}>
                    {
                        selectedCategory?.products?.map((product) =>
                                <div className={'col-span-5 md:col-span-2'} key={product.id}>
                                    <RadioButton
                                        input={{
                                            checked: selectedCategoryProduct?.id === product.id,
                                            value: product.id,
                                            onChange: (e) => {
                                                orderEntryDispatch({type: 'setSelectedCategoryProduct', value: product});
                                                form.change('problem_1', null);
                                                form.change('problem_2', null);
                                                form.change('otherProduct', null);
                                                orderEntryDispatch({type: 'setOtherProductConversionButton', value: false});
                                                orderEntryDispatch({type: 'setSelectedPurchaseDate', value: null});
                                                trackConversion({
                                                    action: 'OrderEntryClickProduct:'+(product.id),
                                                    resourceId: product.id,
                                                    resourceType: 'App\\Models\\Product'
                                                });
                                            },
                                        }}
                                        field={{
                                            titel: product.description,
                                            image: product.image,
                                        }}
                                        meta={{}}
                                    />
                                </div>,
                            )
                    }
                </div>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

